import React from "react";
import { Flex, Icon } from "@chakra-ui/react";

import { BiDotsVertical } from "react-icons/bi";

const MoreOptionsIcon = () => {
  return (
    <Flex p="2" align="center">
      <Icon as={BiDotsVertical} w={5} h={5} />
    </Flex>
  );
};

export default MoreOptionsIcon;
